import { render, staticRenderFns } from "./dialog-detail-backup.vue?vue&type=template&id=0f87af0a&"
import script from "./dialog-detail-backup.vue?vue&type=script&lang=js&"
export * from "./dialog-detail-backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports